import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { showError } from '../../../../utils/Notifications';
import roleService from '../services/role.service';
// import { RoleSaveRequestDto } from '../dto/request/role-save-request.dto';
import { RoleResponseDto } from '../dto/response/role-response.dto';

const initialState = {
  status: 'idle',
  roles: null as RoleResponseDto[] | null,
  role: null as RoleResponseDto | null,
  error: null as string | null,
};

export const fetchRoles = createAsyncThunk('roles/fetchRoles', async () => {
  return await roleService.fetchRoles();
});

// export const fetchRoleById = createAsyncThunk(
//   'roles/fetchRoleById',
//   async (id: string) => {
//     return await roleService.fetchRoleById(id);
//   }
// );

// export const createRole = createAsyncThunk(
//   'roles/createRole',
//   async (data: RoleSaveRequestDto) => {
//     return await roleService.createRole(data);
//   }
// );

// export const updateRole = createAsyncThunk(
//   'roles/updateRole',
//   async (payload: { id: string; role: RoleSaveRequestDto }) => {
//     const { id, role } = payload;
//     return await roleService.updateRole(id, role);
//   }
// );

// export const deleteRole = createAsyncThunk(
//   'roles/deleteRole',
//   async (id: string, { rejectWithValue, dispatch }) => {
//     try {
//       await roleService.deleteRole(id);
//       dispatch(fetchRoles());
//     } catch (e) {
//       return rejectWithValue((e as AxiosError).response?.data ?? 'Failed');
//     }
//   }
// );

const roleSlice = createSlice({
  name: 'roleSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.roles = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.status = 'failed';
        showError(`Fetch roles failed. ${action.payload as string}`);
        state.error = action.error?.message ?? null;
      });
    // .addCase(fetchRoleById.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(fetchRoleById.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   state.role = action.payload;
    // })
    // .addCase(fetchRoleById.rejected, (state, action) => {
    //   state.status = 'failed';
    //   showError(`Fetch role failed. ${action.payload as string}`);
    //   state.error = action.error?.message ?? null;
    // })
    // .addCase(createRole.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(createRole.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   showSuccess(`Role created successfully.`);
    //   state.roles?.push(action.payload);
    // })
    // .addCase(createRole.rejected, (state, action) => {
    //   state.status = 'failed';
    //   showError(`Create role failed. ${action.payload as string}`);
    //   state.error = action.error?.message ?? null;
    // })
    // .addCase(updateRole.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(updateRole.fulfilled, (state, action) => {
    //   state.status = 'succeeded';
    //   showSuccess(`Role updated successfully.`);
    //   if (state.roles) {
    //     const RoleIndex = state.roles.findIndex(
    //       (role) => role.id === action.payload.id
    //     );
    //     if (RoleIndex !== -1) {
    //       state.roles[RoleIndex] = action.payload;
    //     }
    //   }
    // })
    // .addCase(updateRole.rejected, (state, action) => {
    //   state.status = 'failed';
    //   showError(`Update role failed. ${action.payload as string}`);
    //   state.error = action.error?.message ?? null;
    // })
    // .addCase(deleteRole.pending, (state) => {
    //   state.status = 'loading';
    // })
    // .addCase(deleteRole.fulfilled, (state) => {
    //   state.status = 'succeeded';
    //   showSuccess('Role deleted successfully.');
    // })
    // .addCase(deleteRole.rejected, (state, action) => {
    //   state.status = 'failed';
    //   state.error = action.error?.message ?? null;
    //   showError(`Deleting role failed. ${action.payload as string}`);
    // });
  },
});

export default roleSlice.reducer;
